import { Employee } from '../Employee';
import { Employer } from '../Employer';
import { timezone } from './MomentTestSupport';
import moment from 'moment-timezone';
import { CzechSalaryType } from './CzechSalaryType';
import { CzechSalaryComponentProvider } from './CzechSalaryComponentProvider';
import { CzechSalaryComponent } from './CzechSalaryComponent';
import { PayPeriodInterval } from '../PayPeriodInterval';
import { getEndOfPayPeriodInterval } from '../utils/getEndOfPayPeriodInterval';

interface ComponentRecord extends CzechSalaryComponent<"external"> {
  employeeId: string;
  employerId: string;
  monthStart: string;
}

export class InMemoryCzechSalaryComponentProvider
  implements CzechSalaryComponentProvider {
  private records: Record<string, ComponentRecord> = {};

  public add(key: string, record: ComponentRecord): this {
    this.records[key] = record;
    return this;
  }

  public addMany(records: Record<string, ComponentRecord>): this {
    this.records = {
      ...this.records,
      ...records,
    };
    return this;
  }

  public async listForInterval(
    employeeId: Employee["id"],
    employerId: Employer["id"],
    type: CzechSalaryType,
    interval: PayPeriodInterval,
  ): Promise<Record<string, ComponentRecord>> {
    return Object.fromEntries(Object.entries(this.records).filter(([_, record]) => {
      if (
        employeeId !== record.employeeId ||
        employerId !== record.employerId ||
        type !== record.salaryType
      ) {
        return false;
      }

      const intervalStarts = moment.tz(interval.startsOn, timezone);
      const intervalEnds = getEndOfPayPeriodInterval(interval, timezone);
      const monthStart = moment.tz(record.monthStart, timezone);
      return monthStart.isBetween(intervalStarts, intervalEnds, undefined, '[]');
    }));
  }
}
